export const SET_FOLIO_ERROR_ORDERS = 'SET_FOLIO_ERROR_ORDERS'
export const SET_FOLIO_ERROR_IS_LOADING = 'SET_FOLIO_ERROR_IS_LOADING'
export const SET_FOLIO_ERROR_IS_RETRYING = 'SET_FOLIO_ERROR_IS_RETRYING'
export const SET_FOLIO_ERROR_MODAL_IS_OPEN = 'SET_FOLIO_ERROR_MODAL_IS_OPEN'
